import { useMount } from 'react-use';

import { GuardianMedicalLeaveFormController, GuardianMedicalLeaveFormGuardian } from '../../guardianMedicalLeave.types';

import { useSetAddress, useSetBirthDate } from './GuardianSelect.hooks';

type GuardianSelectDefaultGuardianProps = {
   readonly controller: GuardianMedicalLeaveFormController;
   readonly guardian: GuardianMedicalLeaveFormGuardian;
   readonly shouldUseDefaultGuardianAddress: boolean;
};

export const GuardianSelectDefaultGuardian = (props: GuardianSelectDefaultGuardianProps): null => {
   const { guardian } = props;
   const setAddress = useSetAddress(props.controller);
   const setBirthDate = useSetBirthDate(props.controller);
   useMount(() => {
      props.controller.setValue('guardian', {
         firstName: guardian.firstName,
         middleName: guardian.middleName,
         lastName: guardian.lastName,
         guardianExternalIdentifier: guardian.guardianExternalIdentifier,
         address: guardian.address,
         birthDate: guardian.birthDate,
      });
      props.controller.setValue('relationCode', guardian.relationCode ?? 'CHILD');
      if (props.shouldUseDefaultGuardianAddress) {
         setAddress(guardian.address ?? undefined);
         setBirthDate(guardian.birthDate ?? undefined);
      }
   });

   return null;
};
